module.exports = __webpack_public_path__ + "img/not-delivered.ee9f9d91.svg";